import type { ReactNode } from "react";

export const Noop = ({ children }: { children: ReactNode }): JSX.Element => (
  <>{children}</>
);
